import { useMemo, useRef, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import ptLocale from '@fullcalendar/core/locales/pt-br';
import { Event } from '../types';

type EventCalendarProps = {
  events: Event[];
  onSelectEvent: (event: Event) => void;
};

const EventCalendar = ({ events, onSelectEvent }: EventCalendarProps) => {
  const [title, setTitle] = useState('');
  const calendarRef = useRef<FullCalendar | null>(null);

  const mappedEvents = useMemo(
    () =>
      events.map((event) => ({
        id: event.id,
        title: event.title,
        start: event.startAt,
        end: event.endAt,
      })),
    [events]
  );

  return (
    <div className="calendar-shell calendar-panel p-4 h-100 shadow-lg">
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3">
        <div>
          <h5 className="mb-1 text-white">Calendário público</h5>
          <p className="text-white-50 mb-0">Visualize os eventos publicados no calendário.</p>
        </div>
        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="btn btn-outline-light btn-sm"
            onClick={() => calendarRef.current?.getApi().prev()}
          >
            ‹
          </button>
          <button
            type="button"
            className="btn btn-outline-light btn-sm"
            onClick={() => calendarRef.current?.getApi().today()}
          >
            Hoje
          </button>
          <button
            type="button"
            className="btn btn-outline-light btn-sm"
            onClick={() => calendarRef.current?.getApi().next()}
          >
            ›
          </button>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between mb-3">
        <span className="badge badge-approved fw-semibold">Publicados</span>
        <strong className="text-white">{title}</strong>
      </div>

      <div className="calendar-wrapper rounded-4 overflow-hidden p-0 bg-transparent border-0">
        <FullCalendar
          ref={calendarRef}
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          locale={ptLocale}
          headerToolbar={false}
          events={mappedEvents}
          height="auto"
          eventDisplay="block"
          eventClassNames="fc-event-card"
          dayMaxEvents={2}
          datesSet={(arg) => setTitle(arg.view.title)}
          eventClick={(info) => {
            const event = events.find((item) => item.id === info.event.id);
            if (event) {
              onSelectEvent(event);
            }
          }}
        />
      </div>
    </div>
  );
};

export default EventCalendar;
